import { render } from "./BananaCardItemVoluntarily.vue?vue&type=template&id=1c18440b&scoped=true"
import script from "./BananaCardItemVoluntarily.vue?vue&type=script&lang=js"
export * from "./BananaCardItemVoluntarily.vue?vue&type=script&lang=js"

import "./BananaCardItemVoluntarily.vue?vue&type=style&index=0&id=1c18440b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c18440b"]])

export default __exports__